(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll-customer-moments"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ll-customer-moments')) {
  customElements.define('ll-customer-moments', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('[data-customer-moments-track]');
      if (!track) return;
      const previous = this.querySelector('[data-customer-moments-prev]');
      const next = this.querySelector('[data-customer-moments-next]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const videos = [...this.querySelectorAll('video')];
      const visible = new Set();
      const update = () => {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => {
        const card = track.querySelector('.ll-customer-moments__card');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({left: direction * step * (window.innerWidth < 768 ? 2 : 4), behavior: reduced.matches ? 'auto' : 'smooth'});
      };
      const sync = () => {
        videos.forEach(video => {
          if (visible.has(video) && !document.hidden && !this.querySelector('dialog[open]') && !reduced.matches) {
            const promise = video.play();
            if (promise) promise.catch(() => {});
          } else video.pause();
        });
      };
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive:true, signal});
      window.addEventListener('resize', update, {passive:true, signal});
      document.addEventListener('visibilitychange', sync, {signal});
      reduced.addEventListener('change', sync, {signal});
      videos.forEach(video => {
        video.muted = true;
      });
      if ('IntersectionObserver' in window) {
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= .5) visible.add(entry.target);
            else visible.delete(entry.target);
          });
          sync();
        }, {threshold:[0,.5]});
        videos.forEach(video => this.videoObserver.observe(video));
      } else {
        videos.forEach(video => visible.add(video));
        sync();
      }
      this.querySelectorAll('[data-look-open]').forEach(link => {
        const dialog = this.querySelector(`#${CSS.escape(link.getAttribute('aria-controls'))}`);
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !dialog || !dialog.showModal) return;
          event.preventDefault();
          dialog.showModal();
          sync();
        }, {signal});
        if (!dialog) return;
        dialog.addEventListener('close', () => {link.focus({preventScroll:true}); sync();}, {signal});
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        }, {signal});
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
      }
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.videoObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
